// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { User } from "./User";
import { UserFromJSON, UserFromJSONTyped, UserToJSON, UserToJSONTyped } from "./User";
import type { Descriptor } from "./Descriptor";
import {
  DescriptorFromJSON,
  DescriptorFromJSONTyped,
  DescriptorToJSON,
  DescriptorToJSONTyped,
} from "./Descriptor";

/**
 * Renamed to avoid conflict with Typescript built-in 'File' type
 * @export
 * @interface PublicationVersionFileModel
 */
export interface PublicationVersionFileModel {
  /**
   *
   */
  type?: PublicationVersionFileModelTypeEnum;
  /**
   *
   */
  id: string;
  /**
   *
   */
  lastModified: Date;
  /**
   *
   */
  size: number;
  /**
   *
   */
  etag: string;
  /**
   *
   */
  user: User;
  /**
   *
   */
  mediaType: string;
  /**
   *
   */
  descriptorId: string;
  /**
   *
   */
  url: string;
  /**
   * This field is null when the file has not yet been identified.
   */
  dataType?: string | null;
  /**
   *
   */
  descriptor?: Descriptor | null;
}

/**
 * @export
 */
export const PublicationVersionFileModelTypeEnum = {
  File: "file",
} as const;
export type PublicationVersionFileModelTypeEnum =
  (typeof PublicationVersionFileModelTypeEnum)[keyof typeof PublicationVersionFileModelTypeEnum];

/**
 * Check if a given object implements the PublicationVersionFileModel interface.
 */
export function instanceOfPublicationVersionFileModel(
  value: object
): value is PublicationVersionFileModel {
  if (!("id" in value) || value["id"] === undefined) return false;
  if (
    (!("lastModified" in (value as Record<string, any>)) &&
      !("last_modified" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["lastModified"] === undefined &&
      (value as Record<string, any>)["last_modified"] === undefined)
  )
    return false;
  if (!("size" in value) || value["size"] === undefined) return false;
  if (!("etag" in value) || value["etag"] === undefined) return false;
  if (!("user" in value) || value["user"] === undefined) return false;
  if (
    (!("mediaType" in (value as Record<string, any>)) &&
      !("media_type" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["mediaType"] === undefined &&
      (value as Record<string, any>)["media_type"] === undefined)
  )
    return false;
  if (
    (!("descriptorId" in (value as Record<string, any>)) &&
      !("descriptor_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["descriptorId"] === undefined &&
      (value as Record<string, any>)["descriptor_id"] === undefined)
  )
    return false;
  if (!("url" in value) || value["url"] === undefined) return false;
  return true;
}

export function PublicationVersionFileModelFromJSON(json: any): PublicationVersionFileModel {
  return PublicationVersionFileModelFromJSONTyped(json, false);
}

export function PublicationVersionFileModelFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PublicationVersionFileModel {
  if (json == null) {
    return json;
  }
  return {
    type: json["type"] == null ? undefined : json["type"],
    id: json["id"],
    lastModified:
      json["last_modified"] == null ? json["last_modified"] : parseDateTime(json["last_modified"]),
    size: json["size"],
    etag: json["etag"],
    user: UserFromJSON(json["user"]),
    mediaType: json["media_type"],
    descriptorId: json["descriptor_id"],
    url: json["url"],
    dataType:
      json["data_type"] === undefined
        ? undefined
        : json["data_type"] === null
        ? null
        : json["data_type"],
    descriptor:
      json["descriptor"] === undefined
        ? undefined
        : json["descriptor"] === null
        ? null
        : DescriptorFromJSON(json["descriptor"]),
  };
}

export function PublicationVersionFileModelToJSON(json: any): PublicationVersionFileModel {
  return PublicationVersionFileModelToJSONTyped(json, false);
}

export function PublicationVersionFileModelToJSONTyped(
  value?: PublicationVersionFileModel | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    type: value["type"],
    id: value["id"],
    last_modified:
      value["lastModified"] == null
        ? value["lastModified"]
        : serializeDateTime(value["lastModified"]),
    size: value["size"],
    etag: value["etag"],
    user: UserToJSON(value["user"]),
    media_type: value["mediaType"],
    descriptor_id: value["descriptorId"],
    url: value["url"],
    data_type: value["dataType"],
    descriptor: DescriptorToJSON(value["descriptor"]),
  };
}
